import Auth from '../auth/Auth';
import Company from "../models/Company";
import Product from "../models/Product";
import { WebClient } from './WebClient'

class ApiCompany extends WebClient {
    async getCompanies(): Promise<Company[]> {
        const url = "/company";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }
    
    async getProducts(): Promise<Product[]> {
        const url = "/company/product";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }
}

export default new ApiCompany();
